import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = { style: {"font-size":"18px","color":"#333333"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'
import { row } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/commission/ratio/page': fetchList,
  // 提成率导出
  'POST/commission/ratio/export': exportApi,
  // 导入提成项目
  'POST/commission/import/ratio': importRatioApi,
  // 下载模板
  'POST/commission/download/template/ratio': downloadApi,
  // 新增提成项目
  'POST/commission/ratio/add': addApi,
  // 删除提成项目
  'DELETE/commission/ratio/del': delApi,
  // 获取提成项目
  'GET/commission/types': typesApi,
} = Api

const seleRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let typeList = ref<{id: number, item: string}[]>([])
typesApi().then((rep) => {
  typeList.value = rep
})

const searchEle = ref()
const searchObj = reactive({
  month: "", orderNo: "", dataType: null, alias: '',
  typeId: null, note: ''
})
const searchHandle = () => {
  searchObj.dataType = searchObj.dataType || null
  searchObj.typeId = searchObj.typeId || null
  fetchData(searchObj)
}
searchHandle()

// 导出
const expHandle = () => {
  ElMessageBox.confirm('请确认是否导出', '提示').then(() => {
    return exportHandle(exportApi, MI_params)
  }).then(() => {
    ElMessage.success('导出成功')
  })
}

// 导入完成提示
const isShowTips = ref<boolean>(false)
let tipsObj: any = ref({})
const tipsImport = (result: object) => {
  let arr = Object.keys(result)
  if(arr.length === 0) return;
  tipsObj.value = result
  isShowTips.value = true
}

// 新增提成项目
const isShowAdd = ref<boolean>(false)
const addEle = ref()
const btnLoad = ref<boolean>(false)
const addObj: any = reactive({
  "commissionDate": "",
  "orderNo": "",
  "typeId": '',
  "name": "",
  "data": '',
  "note": "",
  "compute": true,
  "companyId": '',
  "userId": ''
})
const addHandle = () => {
  addEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    btnLoad.value = true
    return addApi({
      ...addObj,
      name: addObj.name.alias,
      userId: addObj.name.userId,
    })
  }).then(() => {
    ElMessage.success('添加成功')
    isShowAdd.value = false
    searchHandle()
  }).finally(() => {
    btnLoad.value = false
  })
}



// 删除提成项目
const delHandle = () => {
  ElMessageBox.confirm('请确认是否删除', '提示').then(() => {
    MI_identify.value = true
    return delApi({ids: seleRows.value.map((e: {id: number}) => e.id)})
  }).then(() => {
    ElMessage.success('删除成功')
    MI_identify.value = false
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "searchEle",
      ref: searchEle,
      model: _unref(searchObj),
      "label-width": "auto",
      inline: "",
      class: "searchBg mb-10",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "月份:",
          prop: "month"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(searchObj).month,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).month) = $event)),
              "value-format": "YYYY-MM-DD",
              type: "month",
              placeholder: "请选择月份"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "订单编号:",
          prop: "orderNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(searchObj).orderNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
              placeholder: "请输入订单编号",
              clearable: "",
              class: "form-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "姓名:",
          prop: "alias"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(searchObj).alias,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).alias) = $event)),
              placeholder: "请输入姓名",
              clearable: "",
              class: "form-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "数据类型:",
          prop: "dataType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(searchObj).dataType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).dataType) = $event)),
              placeholder: "请选择数据类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "MANUAL",
                  value: "MANUAL"
                }),
                _createVNode(_component_el_option, {
                  label: "CO2",
                  value: "CO2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "类型:",
          prop: "typeId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(searchObj).typeId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).typeId) = $event)),
              placeholder: "请选择类型",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.item,
                    value: item.id,
                    key: item.item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注:",
          prop: "note"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(searchObj).note,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).note) = $event)),
              placeholder: "请输入备注",
              clearable: "",
              class: "form-input",
              maxlength: "200"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (searchHandle())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (searchEle.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (isShowAdd.value = true)),
      disabled: _unref(MI_identify),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[9] || (_cache[9] = ($event: any) => (delHandle())),
      disabled: _unref(MI_identify) || seleRows.value.length === 0,
      type: "danger"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[10] || (_cache[10] = ($event: any) => (expHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_TheUpBtn, {
      upText: "导入",
      upFetch: _unref(importRatioApi),
      upParams: {},
      onUpSuccess: tipsImport,
      disabled: _unref(MI_identify),
      showBtn: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_eptBtn, {
          type: "primary",
          exportFn: _unref(downloadApi),
          exportText: '下载提成项目模板',
          isDirect: true
        }, null, 8, ["exportFn"])
      ]),
      _: 1
    }, 8, ["upFetch", "disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      class: "mt-10",
      onSelectionChange: _cache[11] || (_cache[11] = (rows) => seleRows.value = rows),
      "max-height": _unref(MI_height) - 135 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          selectable: (row) => row.dataType !== 'CO2'
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, {
          label: "提成日期",
          prop: "commissionDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单编号",
          prop: "orderNo"
        }),
        _createVNode(_component_el_table_column, {
          label: "提成项目",
          prop: "item"
        }),
        _createVNode(_component_el_table_column, {
          label: "Name",
          prop: "name"
        }),
        _createVNode(_component_el_table_column, {
          label: "提成率",
          prop: "ratio",
          align: "right",
          formatter: (row) => row.ratio + '%'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "CO2提成率",
          prop: "co2Ratio",
          align: "right",
          formatter: (row) => row.co2Ratio ?  row.co2Ratio + '%' : '-'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "数据类型",
          prop: "dataType"
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否计算",
          prop: "compute",
          width: "100",
          formatter: (row) => row.compute ? '是' : '否'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "所属公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 100, 300, 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowTips.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowTips).value = $event)),
      title: "导入提示"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (isShowTips.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(tipsObj)), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(tipsObj)[item].join('，')), 1)
          ], 64))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((isShowAdd).value = $event)),
      title: "新增",
      onClose: _cache[27] || (_cache[27] = ($event: any) => (addEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[24] || (_cache[24] = ($event: any) => (isShowAdd.value = false)),
          disabled: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (addHandle())),
          loading: btnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addEle",
          ref: addEle,
          model: _unref(addObj),
          "label-position": "top",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "提成日期:",
              prop: "commissionDate",
              rules: [{ required: true, message: '请选择日期', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(addObj).commissionDate,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(addObj).commissionDate) = $event)),
                  "value-format": "YYYY-MM-DD",
                  clearable: "",
                  type: "date",
                  placeholder: "请选择日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单编号:",
              prop: "orderNo",
              rules: [{ required: true, message: '请输入编号', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).orderNo,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(addObj).orderNo) = $event)),
                  placeholder: "请输入订单编号",
                  maxlength: "100",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型:",
              prop: "typeId",
              rules: [{ required: true, message: '请选择类型', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addObj).typeId,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addObj).typeId) = $event)),
                  placeholder: "请选择类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.item,
                        value: item.id,
                        key: item.item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Name:",
              prop: "name",
              rules: [{ required: true, message: '请选择', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addObj).name,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addObj).name) = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  filterable: "",
                  "value-key": "userId"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: `${user.alias} (${user.realName})`,
                        value: user
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "金额:",
              prop: "data",
              rules: [{ required: true, message: '请输入金额', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).data,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addObj).data) = $event)),
                  placeholder: "请输入金额",
                  maxlength: "100",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否计算:",
              prop: "compute",
              rules: [{ required: true, message: '请选择是否计算', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addObj).compute,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(addObj).compute) = $event)),
                  placeholder: "请选择是否计算",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "是",
                      value: true
                    }),
                    _createVNode(_component_el_option, {
                      label: "否",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司:",
              prop: "companyId",
              rules: [{ required: true, message: '请选择公司', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addObj).companyId,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(addObj).companyId) = $event)),
                  placeholder: "请选择公司",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.id,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_8,
            _createVNode(_component_el_form_item, {
              label: "备注:",
              prop: "note",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).note,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(addObj).note) = $event)),
                  type: "textarea",
                  class: "form-input",
                  placeholder: "请输入备注",
                  maxlength: "500",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})